import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import AppShell from "./pages/AppShell";
import AdminPage from "./pages/AdminPage";
import AccountPage from "./pages/AccountPage";
import AuthCallback from "./pages/AuthCallback";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import "@/App.css";

function RootRouter() {
  const location = useLocation();
  // Emergent Google Auth returns with #session_id=... — handle it before anything else.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<AppShell />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="*" element={<AppShell />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <RootRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}
